import { render, staticRenderFns } from "./OldArrearageList.vue?vue&type=template&id=32d8740c&scoped=true"
import script from "./OldArrearageList.vue?vue&type=script&lang=js"
export * from "./OldArrearageList.vue?vue&type=script&lang=js"
import style0 from "./OldArrearageList.vue?vue&type=style&index=0&id=32d8740c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d8740c",
  null
  
)

export default component.exports